import React from "react"
import { useDrag, useDrop } from "react-dnd"
import { Preferito } from "../models/ServiceDescriptor"
// import logConstants from "../utils/logConstants"

const ItemTypes = {
    PREF_CARD: 'prefCard'
}

export const dumpPrefArray = (temp: Preferito[]) => temp.map((x, index) => `${index}-${x.id}`).join(', ')
const findCardIndex = (preferiti: Preferito[], id: number) => preferiti?.findIndex(x => x.id === id) ?? -1
const usePerfOrder = (preferiti: Preferito[], ref: React.RefObject<HTMLDivElement>, prefId: number, draggingOpacity: number = 0, onMove: (newpref?: Preferito[]) => void) => {
    const [{ isDragging }, drag, preview] = useDrag(() => ({
        type: ItemTypes.PREF_CARD,
        item: ({ prefId }),
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging()
        })
    }))

    const [{ isOver, dragItem, isInsertLeft,  isInsertRight }, drop] = useDrop(
        () => ({
            accept: ItemTypes.PREF_CARD,
            drop: (item: { prefId: number }) => {
                const dragIndex = findCardIndex(preferiti, item.prefId)
                const dropIndex = findCardIndex(preferiti, prefId)
                // console.log(`%cdropping ${JSON.stringify(item)} [${dragIndex}] on ${prefId} [${dropIndex}]`, logConstants.green12ptBold)
                if (dragIndex === dropIndex) return
                const temp = [...preferiti]
                const elimina = temp.splice(dragIndex, 1)
                if (dragIndex < dropIndex) {
                    // console.log(`%cdropping ${dragIndex} < ${dropIndex} ... ${dumpPrefArray(temp)}`, logConstants.magenta10ptBold)
                    temp.splice(dropIndex, 0, elimina[0])
                } else {
                    // console.log(`%cdropping ${dragIndex} > ${dropIndex} ... ${dumpPrefArray(temp)}`, logConstants.magenta10ptBold)
                    temp.splice(dropIndex, 0, elimina[0])
                }
                onMove && onMove(temp)
                return ({ prefId })
            },
            collect: (monitor) => {
                const isOver = monitor.isOver()
                const dragItem = monitor.getItem<{prefId: number}>()
                const dragIndex = dragItem?.prefId ? findCardIndex(preferiti, dragItem.prefId) : 0
                const dropIndex = prefId ? findCardIndex(preferiti, prefId) : 0
                const isInsertLeft = isOver && dragIndex > dropIndex
                const isInsertRight = isOver && dragIndex < dropIndex

                return ({
                    isOver,
                    dragItem,
                    isInsertLeft,
                    isInsertRight, 
                })
            },
        }),
        [preferiti],
    )

    const opacity = isDragging ? draggingOpacity : 1

    return {
        dragItem,
        isDragging,
        isOver,
        drag,
        preview,
        drop,
        opacity,
        isInsertRight,
        isInsertLeft,
        // order,
        // dropSegment,
        // dragItemIndex,
        // isRightOver,
    }
}

export default usePerfOrder